import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import { useDebounce } from 'use-lodash-debounce'
import useSelfpointEffect from '../common3/hooks/useSelfpointEffect'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import filterString from '../common3/filterString'
import UnconfiguredComponent from '../common3/UnconfiguredComponent'

import { Table, Wrapper, THead, TBody, TR, TD, TH } from '../Table/styled'

const TextTD = styled(TD)`
  padding: 10px 15px;
`

export default (props) => {
  const [loading, effect] = useSelfpointEffect(props)

  const { extra = {}, save, id } = props;
  const { configuration = [], saveTable = false } = extra;

  const ticketLists = effect && effect.data ? effect.data : effect;

  useEffect(() => {
    if (saveTable) {
      const saveValue = ticketLists && Array.isArray(ticketLists) && ticketLists.map(row => (
        configuration && configuration.map(col => {
          const thisColumn = get(col, ['content'], '')

          return filterString(thisColumn, props, row)
        }))
      )

      saveValue && save({ key: id, value: saveValue })
    }
  }, [ticketLists])

  return (
    <Wrapper>
      <Table>

        <THead>
          <TR>
            {
              configuration && configuration.map((col, i) => {
                const thisColumn = get(col, ['heading'], '')
                return <TH key={`th${i}`}>{thisColumn}</TH>
              })
            }
          </TR>
        </THead>
        <TBody>

          {
            ticketLists && Array.isArray(ticketLists) && ticketLists.map((row, rowIndex) => {

              return (
                <TR key={`tr-${rowIndex}`}>
                  {
                    configuration && configuration.map((col, colIndex) => {
                      const thisColumn = get(col, ['content'], '')
                      if (col.isLink) {

                        return <TextTD key={`td-${rowIndex}${colIndex}`}><Link to={`${col.to}${col.toParams && '?' + filterString(col.toParams, props, row)}`}>{filterString(thisColumn, props, row)}</Link></TextTD>
                      }
                      return <TextTD key={`td-${rowIndex}${colIndex}`}>{filterString(thisColumn, props, row)}</TextTD>
                    })
                  }
                </TR>
              )
            })
          }
        </TBody>

      </Table>
    </Wrapper>

  );
};
